import type { FeatureFlag } from '@/scopes/common/domain/types';
import type { FeatureOwners } from '@/scopes/common/infrastructure/feature-flags/constants';
import { featureOwnersColors } from '@/scopes/common/infrastructure/feature-flags/constants';

export function flag({ name, owner }: { name: string; owner: FeatureOwners }): FeatureFlag {
  return { name, owner, color: featureOwnersColors[owner] };
}
